import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {PaqueteSegurosSeguros} from '../_models/paquete-seguros-seguros';
import {PlagaProductoAgricola} from '../_models/plaga-producto-agricola';
import {PaqueteSegurosSegurosPlanes} from '../_models/paquete-seguros-seguros-planes';
@Injectable({
  providedIn: 'root'
})
export class PaqueteSegurosSegurosPlanesService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/paquetesSegurosSegurosPlanes';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PaqueteSegurosSegurosPlanes[] ) );
  }

  listadoPorPaquete( id: string ) {
    return this.httClient.get( this.rutServicio + '/paqueteSeguro/' + id ).pipe( map( res => res as PaqueteSegurosSegurosPlanes[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PaqueteSegurosSegurosPlanes[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PaqueteSegurosSegurosPlanes ) );
  }

  crear( regCrear: PaqueteSegurosSegurosPlanes ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PaqueteSegurosSegurosPlanes ) );
  }

  actualizar( regActualizar: PaqueteSegurosSegurosPlanes ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
